import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import blue from '../../assets/images/market/mark_grp.svg';
import red from '../../assets/images/market/mark_grp_rd.svg';

import './market_styles/marketupper.css';
import Chartt from '../graph/chartt';

export default function MarketUpper() {
  return (
    <>
      <Container className='mt-5 mb-5 market_upper'>
        <Row className='market_up'>
              <Col lg={3} md={6} className='mrgn'>
              <div className="first_data mar_data d-flex align-items-center gap-2">
              <div className="mar_fst">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="mar_fst_grap">
                <Chartt />
              </div>
            </div>
              </Col>
            
              <Col lg={3} md={6} className='mrgn'>
              <div className="mar_second_data mar_data d-flex align-items-center gap-2">
              <div className="mar_scnd">
                <p>ET/USDT</p>
                <h6 className='mark_up_h6 m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="mar_scnd_grap">
                <Chartt />
              </div>
            </div>
              </Col>
           
            <Col lg={3} md={6} className='mrgn'>
            <div className="mar_third_data mar_data d-flex align-items-center gap-2">
              <div className="mar_trd">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="mar_trd_grap">
                <Chartt />
              </div>
            </div>
            </Col>

            <Col lg={3} md={6} className='mrgn'>
            <div className="mar_forth_data mar_data d-flex align-items-center gap-2">
              <div className="mar_fth">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="mar_fth_grap">
                <Chartt />
              </div>
            </div>            
            </Col>
        </Row>
      </Container>
    </>
  )
}
